import { Injectable, EventEmitter } from '@angular/core';
import {CheckPlatformService} from '@apply4u/services/check-platform.service';

@Injectable({
  providedIn: 'root'
})
export class InfoPopupService {

  isBrowser:boolean = false;
  messageChangedEvent:EventEmitter<string> = new EventEmitter<string>();
  
  constructor(private checkPlatformService:CheckPlatformService) { 

    if(this.checkPlatformService.isBrowser())
    {
      this.isBrowser = true;
    }
  }

  Show(message:string)
  {
    this.messageChangedEvent.emit(message);

    if(this.isBrowser)
    {
      document.getElementById("btnOpenInformationPopUp").click();
    }
  }
}
